import axios_instance from '../utilities/axios_instance';

const TCIService = {
  getTCIData: async (geometry, date) => {
    const URL = '/data/aoi/tci';
    const requestBody = {
      geometry,
      date
    };

    try {
      const response = await axios_instance.post(URL, requestBody);
      return response.data;
    } catch (error) {
      console.error('TCI Service Error:', error);
      throw error;
    }
  }
};

export default TCIService;